export default "SELECT\n    syscall\nFROM syscall_all;";